import { render, staticRenderFns } from "./FarmsSearch.vue?vue&type=template&id=63e4e899"
import script from "./FarmsSearch.vue?vue&type=script&lang=js"
export * from "./FarmsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports